// Generic
export const SET_LOADER = 'SET_LOADER';
export const SET_TITLE = 'SET_TITLE';
export const SET_USER = 'SET_USER';
export const SET_BUSINESS = 'SET_BUSINESS';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_LOGOUT = 'SET_LOGOUT';
export const SET_UPDATER = 'SET_UPDATER';
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_MOBILE = 'SET_MOBILE';
export const SET_NAV = 'SET_NAV';
export const SET_PAGES_MODAL = 'SET_PAGES_MODAL';
export const SET_NOTIFICATION_TOKEN = 'SET_NOTIFICATION_TOKEN';
export const SET_FIREBASE_NOTIFICATIONS = 'SET_FIREBASE_NOTIFICATIONS';
export const SET_BREADCRUMB = 'SET_BREADCRUMB';
export const UPDATE_CRUMB = 'UPDATE_CRUMB';

// DND (psychologists "do not disturb")
export const SET_DND = 'SET_DND';

// VIDEO CALLS
export const SET_STREAM_TOKEN = 'STREAM_TOKEN';
export const SET_VIDEO_SETTINGS = 'SET_VIDEO_SETTINGS';
export const SET_ROOM = 'SET_ROOM';
export const SET_PENDING_CALLS = 'SET_PENDING_CALLS';

// AUDIO CALLS
export const SET_AUDIO_TOKEN = 'SET_AUDIO_TOKEN';
export const SET_AUDIO_SETTINGS = 'SET_AUDIO_SETTINGS';
export const SET_AUDIO_ROOM = 'SET_AUDIO_ROOM';

// CHAT
export const SET_PENDING_MESSAGES = "SET_PENDING_MESSAGES";
export const SET_PENDING_CHATS = "SET_PENDING_CHATS";
export const SET_ACCEPTED_CHAT = "SET_ACCEPTED_CHAT";
export const SET_FINISHED_CHAT = "SET_FINISHED_CHAT";
export const SET_TO_DELETE_CHAT = "SET_TO_DELETE_CHAT";
export const SET_UNREAD_MESSAGES = "SET_UNREAD_MESSAGES";